import React from "react";
import { connect } from "react-redux";
import MMPLShipCard from "../MMPLShipCard";
import { getMDSearchlist } from "../../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipPO,
  getMMPLShipCount,
  getMMPLShipSearch,
  getClients,
  getClientSearchResult,
  getClientLists,
  getShipnameListByClientEmail,
} from "../../Actions/MMPLDashboardAPI";
import ShipPOs from "../ShipPOs";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../../Actions/HelpersAPI";
import { GetKPIData } from "../../Actions/CommonAPI";
import { ExportExcelShip } from "../../Actions/ShipViewAPI";
import axios from "axios";
import API from "../../helpers/api";
import PO from "../../Asset/PO.svg";
import MyPendingTask from "../../Asset/MyPendingTask.svg";
import Awaiting from "../../Asset/Awaiting.svg";
import ShipPendingTask from "../../Asset/ShipPendingTask.svg";
import IHMPending from "../../Asset/IHMPending.svg";
import IHMUpdated from "../../Asset/IHMUpdated.svg";
import shortClosed from "../../Asset/shortClosed.svg";
import Ship from "../../Asset/Ship.svg";
import clear from "../../Asset/clear.svg";
import * as $ from "jquery";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import Tooltip from "@material-ui/core/Tooltip";

class PoSyncDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialSearch: 1,
      initialClientSearch: 1,
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      searchClients: {
        ClientName: "",
        ShipName: "",
        clientSearchResult: [],
      },
      PageNo: 1,
      PgSize: 25,
      EquipmentList: [],
      shipId: 0,
      shipName: "",
      poValidationShipName: "",
      poValidationIMONo: "",
      isShortClosed: false,
      isIhmPart1: false,
      isAwaitingMdAndSdoc: false,
      isPoValidation: false,
      isShipsPendingTask: false,
      isIhmUpdate2: false,
      isPurchaseOrders: true,
      TotalShip: false,
      shipSuccess: false,
      ClientList: [],
      ShipList: [],
      clientId: "",
      clientResult: [],
      clientPagination: null,
      clientLoading: false,
    };
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderMovieTitle = this.renderMovieTitle.bind(this);
    this.SearchShipPOs = this.SearchShipPOs.bind(this);
    this.getShipDetails = this.getShipDetails.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
  }

  componentDidMount() {
    const { dispatch, SearchResult, match } = this.props;
    dispatch({ type: "SubBannerTitle", data: "PO Sync dashboard" });
    let user = JSON.parse(localStorage.getItem("currentUser"));
    dispatch(getClients());
    dispatch(getShipnameList());
    dispatch(getShipnameListByClientEmail(""));
    this.fetchClients();
    // dispatch(GetKPIData());
    //dispatch(getClientLists(this.state));
    // dispatch(getClientSearchResult(this.state));
    // this.getClientData(this.state);
  }

  fetchClients = () => {
    this.setState({ clientLoading: true });
    const params = {
      ClientName: this.state.searchClients.ClientName || "",
      ShipName: this.state.searchClients.ShipName || "",
    };
    axios
      .get(API.PoSyncClients, { params })
      .then((response) => {
        const result = response.data || {};
        const data = result.data || [];
        const mapped = data.map((item) => ({
          clientId: item.clientId,
          clientName: item.clientName,
          totalVessels: item.totalVessels,
          lastPulledDate: null,
          lastRunPulledPo: item.lastRunPulledPOs,
          lastRunIHMPresencePo: item.lastRunIHMPresencePOs,
          isThereIsNo30DaysPo: item.isThereIsNo30DaysPo,
          daysSinceLastPO: item.daysSinceLastPO,
        }));
        this.setState({
          clientResult: mapped,
          clientPagination: result.pagination || null,
          clientLoading: false,
          initialClientSearch: 0,
        });
      })
      .catch(() => {
        this.setState({
          clientResult: [],
          clientPagination: null,
          clientLoading: false,
          initialClientSearch: 0,
        });
      });
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      dispatch,
      ShipNameList,
      SearchResult,
      ClientList,
      ShipList,
      clientSearchResult,
    } = nextProps;
    if (ClientList) {
      prevState.ClientList = ClientList;
    }
    if (ShipList) {
      prevState.ShipList = ShipList;
    }
  }

  MMPLDashboardClientNavigation = (e, clientId) => {
    this.props.dispatch({ type: "Otherpages" });
    this.setState({ show: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Po Sync Dashboard" });
    this.props.history.push(
      `/Home/Management/POSyncDashboardShips/${clientId}`,
    );
    e.preventDefault();
  };

  getShipDetails(action) {
    const { dispatch } = this.props;
    this.state.initialSearch = 1;
    if (action === 1) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = true;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 2) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = true;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 3) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = true;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 4) {
      this.state.poValidationShipName = "";
      this.state.shipName = "";
      this.state.poValidationIMONo = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = true;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "PurchaseOrders", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 5) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = true;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 6) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = true;
      this.state.isIhmUpdate2 = false;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else if (action === 7) {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = true;
      this.state.isIhmPart1 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = false;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      dispatch({
        type: "GetShipPOsSuccess",
        data: [],
      });
      // dispatch(getShipPO(this.state, this.state.PageNo));
    } else {
      this.state.poValidationShipName = "";
      this.state.poValidationIMONo = "";
      this.state.shipName = "";
      this.state.isShortClosed = false;
      this.state.isIhmPart1 = false;
      this.state.isShipsPendingTask = false;
      this.state.isIhmUpdate2 = false;
      this.state.isAwaitingMdAndSdoc = false;
      this.state.isPoValidation = false;
      this.state.isPurchaseOrders = false;
      this.state.TotalShip = true;
      this.state.shipSuccess = false;
      dispatch({ type: "searchSuccess", data: "" });
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.setState({});
      //window.scrollTo(0, document.body.scrollHeight);
      this.props.dispatch({
        type: "getMMPLShipSearchSuccess",
        data: null,
      });
      // dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
  }

  ClearPoSearchField() {
    $(
      "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg",
    ).text("");
    this.state.initialSearch = 1;
    this.state.poValidationShipName = "";
    this.state.poValidationIMONo = "";
    this.props.dispatch({
      type: "GetShipPOsSuccess",
      data: [],
    });
    // this.props.dispatch(getShipPO(this.state, this.state.PageNo));
    this.setState({});
  }

  SearchShips(PgNo) {
    if (this.state.shipName == "") {
      $("#totalShipErrMsg").text("Please enter the ship name");
      return;
    } else {
      $("#totalShipErrMsg").text("");
    }
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearch(this.state, PgNo));
  }

  ClearShipSearchField() {
    this.state.initialSearch = 1;
    this.state.shipName = "";
    $("#totalShipErrMsg").text("");
    this.props.dispatch({
      type: "getMMPLShipSearchSuccess",
      data: null,
    });
    // this.props.dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  handlePOInputChange(e) {
    this.state.poValidationShipName = e.target.value;
    this.setState({});
  }

  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    if (this.state.shipName == "") {
      $("#totalShipErrMsg").text("Please enter the ship name");
    } else {
      $("#totalShipErrMsg").text("");
    }
    this.setState({});
  }

  handleClientInputChange(e, str) {
    // this.state.searchClients[str] = e.target.value;
    // if (str == "ClientName") {
    //   this.setState({
    //     searchClients: { ClientName: e.target.value, ShipName: "" },
    //   });
    //   if (e.target.value == "") {
    //     this.props.dispatch(getShipnameListByClientEmail(""));
    //   } else {
    //     this.props.dispatch({
    //       type: "getshipByEmailSuccess",
    //       data: [],
    //     });
    //   }
    // }
    // this.setState({});
    this.setState({
      searchClients: { ...this.state.searchClients, [str]: e.target.value },
    });
  }

  handleClientSelectChange(value, field, item) {
    // const { dispatch } = this.props;
    // this.state.searchClients[field] = value;
    // if (this.state.searchClients.ClientName != "") {
    //   if (field == "ClientName") {
    //     dispatch(getShipnameListByClientEmail(item.clientEmail));
    //   }
    // } else {
    //   dispatch(getShipnameListByClientEmail(""));
    // }
    // this.setState({});
    this.setState({
      searchClients: { ...this.state.searchClients, [field]: value },
    });
  }

  SearchShipPOs(action, field) {
    if (field !== "povalidation") {
      if (this.state.poValidationShipName == "") {
        $(
          "#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg",
        ).text("Please select the ship name");
        return;
      }
    }
    this.state.initialSearch = 0;
    const { dispatch } = this.props;
    dispatch(getShipPO(this.state));
  }

  SearchClients() {
    this.state.initialSearch = 1;
    this.state.initialClientSearch = 0;
    const { dispatch } = this.props;
    localStorage.setItem(
      "shipName",
      JSON.stringify(this.state.searchClients.ShipName),
    );
    this.fetchClients();
    // dispatch(getClientSearchResult(this.state));
  }

  ClearClientsField() {
    const { dispatch } = this.props;
    const clear = {
      ClientName: "",
      ShipName: "",
      clientSearchResult: [],
    };
    this.setState({ searchClients: clear }, () => {
      // dispatch(getClientSearchResult(this.state));
      this.fetchClients();
    });
  }

  renderMovieTitle(state, val) {
    return state.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  renderClientTitleObj(state, val) {
    return state?.clientName?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  renderShipTitleObj(state, val) {
    return state?.shipName?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
  }

  handleInputChanges(e, field) {
    const { dispatch } = this.props;
    this.state[field] = e.target.value;
    if (this.state.poValidationShipName != "") {
      $(
        "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg",
      ).text("");
    }
    this.setState({});
  }

  handleSelectChange(value, field) {
    this.state[field] = value;
    if (this.state.poValidationShipName != "") {
      $(
        "#poErrMsg,#poValidationErrMsg,#awaitingErrMsg,#ihmPart1ErrMsg,#imhUpdatedErrMsg,#scErrMsg,#pendingShipErrMsg",
      ).text("");
    }
    this.setState({});
  }

  downloadAwaitingExcel = () => {
    const { dispatch } = this.props;
    dispatch(ExportExcelShip());
    this.setState({});
  };

  isGreaterThanDays = (inputDate, days) => {
    if (!inputDate) return false;

    const today = Moment();
    const givenDate = Moment(inputDate);

    const diffDays = today.diff(givenDate, "days");

    return diffDays > days;
  };

  render() {
    const {
      shipMMPLInfo,
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCount,
      MMPLShipList,
      ShipPO,
      ClientPOs,
      clientSearchResult,
    } = this.props;
    const {
      isShortClosed,
      isIhmPart1,
      isAwaitingMdAndSdoc,
      isPoValidation,
      isPurchaseOrders,
      TotalShip,
      PurchaseOrders,
      isShipsPendingTask,
      isIhmUpdate2,
      clientResult,
    } = this.state;
    return (
      <div
        className="full-height pt-3 pb-1 my-4"
        style={{ backgroundColor: "#F1F5F9", borderRadius: 14 }}
      >
        {/* <div className="px-4 pt-4"> */}
        <div className="pt-1 px-2 mx-1 row">
          <div className="col-xl-4 ">
            <label className="label-card pbm10px">Clients</label>
          </div>
          <div className="col-xl-8 my-auto">
            <div className="row pl-2 prd-4 mbm1rem">
              <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                <Autocomplete
                  value={this.state.searchClients.ClientName}
                  items={this.state.ClientList}
                  getItemValue={(item) => item.clientName}
                  renderInput={(props) => {
                    return (
                      <input
                        className="form-control"
                        id="exampleFormControlInput23"
                        placeholder="Client Name"
                        {...props}
                        style={{ border: "1px solid #ffffff" }}
                      />
                    );
                  }}
                  shouldItemRender={this.renderClientTitleObj.bind(this)}
                  renderMenu={(item) => <div className="dropdowns">{item}</div>}
                  renderItem={(item, isHighlighted) => (
                    <div
                      className={`items ${isHighlighted ? "selected-items" : ""
                        }`}
                    >
                      {item.clientName}
                    </div>
                  )}
                  onChange={(e, field) =>
                    this.handleClientInputChange(e, "ClientName")
                  }
                  onSelect={(value, item) =>
                    this.handleClientSelectChange(value, "ClientName", item)
                  }
                />
              </div>

              <div className="autocomplete-wrappers col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 pl-1 prd-3 prm-3">
                <Autocomplete
                  value={this.state.searchClients.ShipName}
                  items={this.state.ShipList}
                  getItemValue={(item) => item}
                  renderInput={(props) => {
                    return (
                      <input
                        className="form-control"
                        id="exampleFormControlInput23"
                        placeholder="Ship Name"
                        {...props}
                        style={{ border: "1px solid #ffffff" }}
                      />
                    );
                  }}
                  shouldItemRender={this.renderMovieTitle.bind(this)}
                  renderMenu={(item) => <div className="dropdowns">{item}</div>}
                  renderItem={(item, isHighlighted) => (
                    <div
                      className={`items ${isHighlighted ? "selected-items" : ""
                        }`}
                    >
                      {item}
                    </div>
                  )}
                  onChange={(e, field) =>
                    this.handleClientInputChange(e, "ShipName")
                  }
                  onSelect={(value) =>
                    this.handleClientSelectChange(value, "ShipName")
                  }
                />
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                <button
                  className="btn btn-primary txtside-btn txtht-btn blue w-100 btnclr"
                  type="submit"
                  onClick={() => this.SearchClients()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 px-1 mb-3">
                <button
                  className="btn txtside-btn txtht-btn w-100 clearbtn clr-butn"
                  onClick={() => this.ClearClientsField()}
                  type="button"
                >
                  <img className="mb-1" src={clear} width={21} height={21} />{" "}
                  Clear{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {clientResult && clientResult.length > 0 ? (
          <div className=" mt-0 mb-4 ml-4 mr-4 cardBck row">
            <div className="col-xl-12 py-3">
              <div className="row px-3">
                {clientResult.map((item, index) => {
                  return (
                    <>
                      <div
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-2 cursor-pointer"
                        onClick={(e) =>
                          this.MMPLDashboardClientNavigation(e, item.clientId)
                        }
                      >
                        <div className="card ccard px-4 pt-3 h-100">
                          {/* <div className="bold-count">{item.totalShips}</div> */}
                          <div className="d-flex pt-1 align-items-center justify-content-between">
                            <div className="bord-title">
                              {item.clientName ?? ""}
                            </div>
                            {item.isThereIsNo30DaysPo && (
                              <Tooltip
                                title={`The POs has not been pulled for the last ${item.daysSinceLastPO ?? 0} days.`}
                                arrow
                                placement="top"
                              >
                                <i
                                  className="fa fa-warning-icon fa-exclamation-triangle fa-lg"
                                  aria-label={`The POs has not been pulled for the last ${item.daysSinceLastPO ?? 0} days.`}
                                ></i>
                              </Tooltip>
                            )}
                          </div>

                          <div
                            className="my-3"
                            style={{ border: "0.1px solid #EEEEEE" }}
                          ></div>
                          <div className="row">
                            <div className="sub-card pb-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Total Vessels
                            </div>
                            <div className="subcard-count pb-2 col-xl-6  col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.totalVessels}
                            </div>
                          </div>
                          {/* <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Last Pulled Date
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.lastPulledDate
                                ? Moment(
                                  new Date(Date.parse(item.lastPulledDate)),
                                ).format("DD MMM YYYY")
                                : "NA"}
                            </div>
                          </div> */}
                          <div className="row">
                            <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              Last Run Pulled PO's
                            </div>
                            <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                              {item.lastRunPulledPo}
                            </div>
                          </div>
                          <div className="row">
                            <div className="sub-card py-2 col-xl-8  col-lg-8 col-md-8 col-sm-8 col-8">
                              Last Run IHM Presence PO's
                            </div>
                            <div className="subcard-count py-2 col-xl-4  col-lg-4 col-md-4 col-sm-4 col-4">
                              {item.lastRunIHMPresencePo}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        ) : this.state.initialClientSearch == 0 ? (
          <div className="mt-0 mb-4 ml-4 mr-4  cardBck row">
            <div className="col-xl-12">
              <h6 className="bold-count no-item-card f-size">No Clients</h6>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    shipMMPLCount: state.MMPLDashboardReducer.ShipMMPLCount,
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipList,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    ShipPO: state.MMPLDashboardReducer.ShipPOs,
    SearchResult: state.MMPLDashboardReducer.SearchResult,
    ClientPOs: state.MMPLDashboardReducer.ClientPOs || [],

    ShipNameList: state.UserManageReducer.ShipNameList,
    clientSearchResult: state.MMPLDashboardReducer.clientSearchResult,
    ClientList: state.MMPLDashboardReducer.ClientList,
    ShipList: state.MMPLDashboardReducer.getshipByEmail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PoSyncDashboard);
